import React, { useState, useEffect, useCallback, useMemo } from "react";
import Table from "../../common/Table/table";
import AddUpdatePhysioservice from "./AddUpdatePhysiotherapy";
import {
  createPhysioServiceSlice,
  getPhysioServiceSlice,
  getPhysiotherapyServiceById,
  updatePhysioServiceMaster,
  deletePhysioServiceMaster,
  resetCreatePhysiotherapyServiceMessage,
  resetUpdatePhysiotherapyServiceMessage,
  resetDeletePhysiotherapyServiceMessage,
} from "../../../store/slices/physioserviceSlice";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import ViewModal from "../../common/viewModal/globalViewModal";

const PhysiotherapyServicemaster = () => {
  const [showModal, setModalVisible] = useState(false);
  const [showDeleteModal, setDeleteModalVisible] = useState(false);
  const [modalAction, setModalAction] = useState("create");
  const [showStatus, setShowStatus] = useState(null);
  const [showGlobalViewModal, setShowGlobalViewModal] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [pageLimit, setPageLimit] = useState(10);
  const[submitLoading, setSubmitLoading] = useState(false);

  const initialState = useMemo(
    () => ({
      serviceDetailName: "",
      pt_price: "",
      client_price: "",
      order: "",
      tax: "",
      status: "Active",
    }),
    []
  );
  const [inputError, setInputError] = useState({
    text: false,
    onlyNumber: false,
    serviceDetailName: "",
  });
  const [formData, setFormData] = useState(initialState);
  const dispatch = useDispatch();
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();

  const {
    physiotherapyServices,
    physiotherapyServiceById,
    createPhysiotherapyServiceSuccessMessage,
    createPhysiotherapyServiceErrorMessage,
    searchMessage,
    updatePhysiotherapyServiceSuccessMessage,
    updatePhysiotherapyServiceErrorMessage,
    deletePhysiotherapyServiceSuccessMessage,
    deletePhysiotherapyServiceErrorMessage,
    currentPage,
    totalPages,
    totalCount,
    loading,
  } = useSelector((state) => state.physiotherapyService);
  const { token } = useSelector((state) => state.auth);
  const { tableStatus } = useSelector((state) => state.tableStatusChange);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const clinicId = clinicInfo?.[0]?.clinicId ||null;

  const fetchPhysioTherapy = useCallback(
    (page = 1, lim = pageLimit, search = searchValue) => {
      if (clinicId && token) {
        dispatch(
          getPhysioServiceSlice({
            clinicId,
            status: tableStatus,
            token,
            currentPage: page,
            limit: lim,
            searchQuery: search || undefined,
          })
        );
      }
    },
    [clinicId, token, dispatch, tableStatus, searchValue,pageLimit]
  );

  useEffect(() => {
    fetchPhysioTherapy();
  }, [fetchPhysioTherapy, showModal, showDeleteModal, showGlobalViewModal]);

  const handlePageChange = (page) => {
    fetchPhysioTherapy(page, pageLimit, searchValue);
  };
 const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);              
    fetchPhysioTherapy(1, newLimit, searchValue); 
  };

  useMemo(() => {
    showTostifyMessageAndReset(
      createPhysiotherapyServiceSuccessMessage,
      showToastifySuccess,
      resetCreatePhysiotherapyServiceMessage
    );
    showTostifyMessageAndReset(
      createPhysiotherapyServiceErrorMessage,
      showToastifyError,
      resetCreatePhysiotherapyServiceMessage
    );
    showTostifyMessageAndReset(
      updatePhysiotherapyServiceSuccessMessage,
      showToastifySuccess,
      resetUpdatePhysiotherapyServiceMessage
    );
    showTostifyMessageAndReset(
      updatePhysiotherapyServiceErrorMessage,
      showToastifyError,
      resetUpdatePhysiotherapyServiceMessage
    );
    showTostifyMessageAndReset(
      deletePhysiotherapyServiceSuccessMessage,
      showToastifySuccess,
      resetDeletePhysiotherapyServiceMessage
    );
    showTostifyMessageAndReset(
      deletePhysiotherapyServiceErrorMessage,
      showToastifyError,
      resetDeletePhysiotherapyServiceMessage
    );
  }, [
    createPhysiotherapyServiceSuccessMessage,
    createPhysiotherapyServiceErrorMessage,
    updatePhysiotherapyServiceSuccessMessage,
    updatePhysiotherapyServiceErrorMessage,
    deletePhysiotherapyServiceSuccessMessage,
    deletePhysiotherapyServiceErrorMessage,
    showTostifyMessageAndReset,
  ]);

  const tableHead = useMemo(
    () => [
      { title: "Service Detail Name", key: "serviceDetailName" },
      { title: "Patient Price", key: "pt_price" },
      { title: "Client Price", key: "client_price" },
      { title: "Tax", key: "tax" },
      { title: "Status", key: "status" },
    ],
    []
  );

const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (name === "serviceDetailName") {
      if (/[^A-Za-z\s]/.test(value)) {
        setInputError((prev) => ({
          ...prev,
          serviceDetailName: "Only alphabets are allowed",
        }));
      } else {
        setInputError((prev) => ({
          ...prev,
          serviceDetailName: "",
        }));
      }
    }
  }, []);

  const handleModal = useCallback((action) => {
    setFormData(initialState);
    setInputError({
      serviceDetailName: "",
    });
    setModalVisible(true);
    setModalAction(action);
  }, [initialState]);

  const handleCreatePhysiotherapyService = useCallback(
    async (e) => {
      e.preventDefault();
      let errors = {};
      if (!formData.serviceDetailName.trim()) {
        errors.serviceDetailName = "Service name is required **";
      }
      else if (!/^[A-Za-z\s]+$/.test(formData.serviceDetailName)) {
        errors.serviceDetailName =
          "Only alphabets are allowed";
      }
      setInputError(errors);
      // stop form submit if error exists
      if (Object.keys(errors).length > 0) return;
 
      setSubmitLoading(true);
      const { onlyNumber, text } = inputError;
      if (text || onlyNumber) return;
      try {
      const action =
        modalAction === "create"
          ? createPhysioServiceSlice
          : updatePhysioServiceMaster;
      await dispatch(action({ ...formData, token, clinicId }));
      fetchPhysioTherapy();
      setModalVisible(false);
      setFormData(initialState);
      setInputError({
        serviceDetailName: "",
      });
      } catch (error) {
        console.error("Error occurred:", error);
      } finally {
        setSubmitLoading(false);
      }
    },
    [
      dispatch,
      modalAction,
      formData,
      token,
      initialState,
      tableStatus,
      inputError,
      clinicId,
      fetchPhysioTherapy,
    ]
  );

  const handleUpdate = (item) => {
    handleModal("update");
    setModalVisible(true);
    setFormData({
      id: item?.id,
      serviceDetailName: item?.serviceDetailName,
      pt_price: item?.pt_price,
      client_price: item?.client_price,
      tax: item?.tax,
      status: item?.status,
    });
  };
  const handleShowGlobalViewModal = async (data) => {
    await dispatch(
      getPhysiotherapyServiceById({
        id: data?.id,
        clinicId,
        token,
      })
    );
    setShowGlobalViewModal(true);
  };

  const handleDelete = useCallback((item) => {
    setDeleteModalVisible(true);
    setFormData({ id: item?.id, serviceDetailName: item?.serviceDetailName });
  }, []);

  const handleConfirmDelete = useCallback(async () => {
    await dispatch(
      deletePhysioServiceMaster({ id: formData?.id, token, clinicId })
    );
    fetchPhysioTherapy();
    setDeleteModalVisible(false);
  }, [dispatch, formData, token, clinicId]);

  const handleUpdateStatus = async (status, item) => {
    const updateData = {
      serviceDetailName: item?.serviceDetailName,
      id: item?.id,
      pt_price: item?.pt_price,
      client_price: item?.client_price,
      tax: item?.tax,
      status,
      token,
      clinicId,
    };

    try {
      await dispatch(updatePhysioServiceMaster(updateData));
      fetchPhysioTherapy();
    } catch (error) {
      console.error(error);
    }
  };

  const handleSearch = useCallback(
    (e) => {
      const value = e.target.value;
      setSearchValue(value);
      fetchPhysioTherapy(1, pageLimit, value);
    },
    [fetchPhysioTherapy, pageLimit]
  );
  return (
    <>
      <Table
        tableHead={tableHead}
        tableBody={physiotherapyServices?.map((item) => ({
          id: item?._id,
          serviceDetailName: item?.serviceDetailName,
          pt_price: item?.pt_price,
          client_price: item?.client_price,
          tax: item?.tax,
          status: item?.status,
        }))}
        handleAddBtn={true}
        addModal={() => handleModal("create")}
        handleEdit={handleUpdate}
        errorMessage={searchMessage}
        handleDelete={handleDelete}
        handleShowGlobalViewModal={handleShowGlobalViewModal}
        showStatus={showStatus}
        setShowStatus={setShowStatus}
        handleUpdateStatus={handleUpdateStatus}
        handleSearch={handleSearch}
    currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={pageLimit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        showPagination={true}
        showLimitDropdown={true}
        searchValue={searchValue}
        isLoading={loading}
      />
      <AddUpdatePhysioservice
        showModal={showModal}
        modalAction={modalAction}
        setModalVisible={setModalVisible}
        formData={formData}
        setFormData={setFormData}
        handleChange={handleChange}
        handleCreatePhysiotherapyService={handleCreatePhysiotherapyService}
        setInputError={setInputError}
        inputError={inputError}
        submitLoading={submitLoading}
        initialState={initialState}
      />
      <Modal
        centered
        show={showDeleteModal}
        onHide={() => setDeleteModalVisible(false)}
        size={"md"}
      >
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Confirm Delete
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setDeleteModalVisible(false)}
          ></button>
        </div>
        <div className="modal-body">
          <p>
            Are you sure you want to Delete the Service Details{" "}
            <strong className="text-dark">{formData?.serviceDetailName}</strong>
            ?
          </p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setDeleteModalVisible(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleConfirmDelete}
          >
            Delete
          </button>
        </div>
      </Modal>
      <ViewModal
        showGlobalViewModal={showGlobalViewModal}
        setShowGlobalViewModal={setShowGlobalViewModal}
        modalSize={"lg"}
        titel={tableHead}
        content={{
          id: physiotherapyServiceById?._id,
          serviceDetailName: physiotherapyServiceById?.serviceDetailName,
          pt_price: physiotherapyServiceById?.pt_price,
          client_price: physiotherapyServiceById?.client_price,
          tax: physiotherapyServiceById?.tax,
          status: physiotherapyServiceById?.status,
        }}
      />
    </>
  );
};

export default PhysiotherapyServicemaster;
